import React, { useState } from "react";
import { Box, CircularProgress } from "@mui/material";

function CANaiPage() {
  const [loading, setLoading] = useState(true);

  // Build the iframe URL
  // - Local dev: Set VITE_CANAI_URL in .env (e.g., http://localhost:8080)
  // - Production: Falls back to same origin /canai/ path
  const iframeUrl = import.meta.env.VITE_CANAI_URL || `${window.location.origin}/canai/`;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        position: "relative",
      }}
    >
      {/* Loading indicator */}
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {/* CANai iframe */}
      <iframe
        src={iframeUrl}
        onLoad={() => setLoading(false)}
        style={{
          flex: 1,
          width: "100%",
          border: "none",
          visibility: loading ? "hidden" : "visible",
        }}
        title="CANai"
        allow="clipboard-read; clipboard-write; microphone"
      />
    </Box>
  );
}

export default CANaiPage;
